exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".color-grey-onfly[data-v-279e5904]{color:#54667a!important}.page-title[data-v-279e5904]{font-weight:700;text-transform:uppercase;font-size:24px}.card-box[data-v-279e5904]{box-shadow:0 4px 8px rgba(0,0,0,.15);border-radius:16px;padding:48px 32px;border:1px solid #d3d3d3;margin-top:48px;display:flex;flex-direction:column;gap:16px}", ""]);

// exports
